import { apiReturnPaginatedResults, apiReturnResults } from '../../../apiFactory/apiReturn';
import {
    type ApiResult,
    type BaseParams,
    type Competition,
    type CreateCompetition,
    type PaginatedResult,
    type PagingParams,
    type PatchCompetitionParams,
    type PostParams,
    Request,
    type ResourceId,
} from '../../../common';
import { links } from '../../../links';

type GetCompetitionParams = BaseParams & { slug: string };

export async function getAdminCompetitions(
    params: BaseParams<PagingParams>,
): Promise<ApiResult<PaginatedResult<Competition>>> {
    return Request.getRequest<PaginatedResult<Competition>>({
        ...params,
        target: links.admin().competitions.collection,
    });
}

export const callGetAdminCompetitions = (params: BaseParams<PagingParams>) =>
    apiReturnPaginatedResults<Competition>(getAdminCompetitions, params);

type CreateCompetitionParams = BaseParams & PostParams<CreateCompetition>;

export async function createCompetition(params: CreateCompetitionParams): Promise<ApiResult<Competition>> {
    return Request.postRequest<Competition>({
        ...params,
        target: links.admin().competitions.collection,
        settings: {
            ...params.settings,
        },
    });
}

export const callCreateCompetition = (params: CreateCompetitionParams) =>
    apiReturnResults<Competition>(createCompetition, params);
export async function getAdminCompetition(params: GetCompetitionParams): Promise<ApiResult<Competition>> {
    return Request.getRequest<Competition>({
        ...params,
        target: links.admin().competitions.single(params.slug).competition(),
    });
}

export const callGetAdminCompetition = (params: GetCompetitionParams) =>
    apiReturnResults<Competition>(getAdminCompetition, params);

export type PatchCompetition = BaseParams & PostParams<PatchCompetitionParams> & { slug: string };

export async function updateCompetition(params: PatchCompetition): Promise<ApiResult<Competition>> {
    return Request.patchRequest<Competition>({
        ...params,
        target: links.admin().competitions.single(params.slug).competition(),
        settings: {
            ...params.settings,
        },
    });
}

export const callUpdateCompetition = (params: PatchCompetition) =>
    apiReturnResults<Competition>(updateCompetition, params);

export type DeleteCompetition = BaseParams & { slug: string; value: { user_id?: ResourceId } };

export async function deleteCompetition(params: DeleteCompetition) {
    return Request.deleteRequest<Competition>({
        ...params,
        target: links.admin().competitions.single(params.slug).competition(),
        settings: {
            ...params.settings,
        },
    });
}

export const callDeleteCompetition = (params: DeleteCompetition) =>
    apiReturnResults<Competition>(deleteCompetition, params);

export type DeleteCompetitionWishlists = BaseParams & {
    id: ResourceId;
    user_id?: ResourceId;
    value: { user_id?: ResourceId; destroy_associated_wishlist?: boolean };
};
export async function deleteCompetitionWishlists(params: DeleteCompetitionWishlists) {
    return Request.deleteRequest({
        ...params,
        target: links.admin().competitions.single(params.id).wishlists(),
        settings: {
            ...params.settings,
        },
    });
}
export const callDeleteCompetitionWishlists = (params: DeleteCompetitionWishlists) =>
    apiReturnResults<Competition>(deleteCompetitionWishlists, params);

export const competitionCalls = {
    callGetAdminCompetitions,
    callCreateCompetition,
    callGetAdminCompetition,
    callUpdateCompetition,
    callDeleteCompetition,
    callDeleteCompetitionWishlists,
};
